import { round } from '@/utils/mathUtils';
import { toast } from 'sonner';

import { GetSupplierDebtApi } from '../api/HandRequest.api';
import type {
  ISuppliars,
  ISuppliarWithDebt,
} from '../api/HandRequest.interface';

interface HandleSupplierSelectionParams {
  value: ISuppliars | null;
  onLoadingChange: (
    isLoading: boolean,
    type: 'upload' | 'update' | 'main',
  ) => void;
  showToast?: boolean;
}

export async function handleSupplierSelection({
  value,
  onLoadingChange,
  showToast = true,
}: HandleSupplierSelectionParams): Promise<ISuppliarWithDebt | null> {
  if (!value) {
    return null;
  }

  try {
    onLoadingChange(true, 'update');
    const debtData = await GetSupplierDebtApi(value?.ID);
    const roundedDebt = round(debtData.data.debt, 2);

    let debtStatus: 'خالص' | 'مديون' | 'دائن';
    if (roundedDebt === 0) {
      debtStatus = 'خالص';
    } else if (roundedDebt < 0) {
      debtStatus = 'مديون';
    } else {
      debtStatus = 'دائن';
    }

    if (showToast) {
      toast.success(`تم جلب بيانات المورد بنجاح. الحساب: ${debtStatus}`);
    }

    return {
      ...value,
      Debt: roundedDebt,
      DebtStatus: debtStatus,
    };
  } catch (error) {
    console.error('Failed to fetch supplier debt:', error);
    if (showToast) {
      toast.error('حدث خطأ أثناء جلب بيانات المورد. تم إعادة تعيين المورد.');
    }
    return null;
  } finally {
    onLoadingChange(false, 'main');
  }
}
